import { motion } from "framer-motion";

const services = [
  {
    key: "paid-call",
    number: "01",
    title: "Paid Strategy Call",
    price: "₹15,000",
    priceNote: "+ GST",
    duration: "90-minute consultation",
    features: [
      "Business analysis",
      "Growth roadmap",
      "Profitability discussion",
      "Recorded session with notes",
    ],
    cta: "Book Now",
    featured: false,
  },
  {
    key: "audit",
    number: "02",
    title: "Nightclub Audit",
    price: "₹75,000",
    priceNote: "+ GST",
    duration: "2-day on-ground audit",
    features: [
      "Operations",
      "Staff efficiency",
      "Guest journey",
      "Menu engineering",
      "Revenue optimisation",
      "Detailed action plan",
    ],
    cta: "Request Audit",
    featured: true,
  },
  {
    key: "pre-launch",
    number: "03",
    title: "Pre-Launch Consulting",
    price: "From Concept",
    priceNote: "Custom scope",
    duration: "Concept → doors-open",
    features: [
      "Brand positioning",
      "Operations setup",
      "Hiring",
      "Menu strategy",
      "Launch planning",
    ],
    cta: "Start Together",
    featured: false,
  },
];

export default function Services({ onOpenForm }) {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-20 md:py-40 bg-[#050505]"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 items-end gap-8 mb-14 md:mb-24">
          <div className="lg:col-span-8">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] mb-5">
              Ch. 03 &mdash; Services
            </div>
            <h2 className="font-display text-white text-[34px] sm:text-4xl md:text-6xl lg:text-[80px] leading-[0.98] tracking-[-0.02em]">
              Three ways we{" "}
              <em className="font-editorial italic text-[#D4AF37] font-light">
                work together.
              </em>
            </h2>
          </div>
          <div className="lg:col-span-4 text-white/60 text-sm md:text-base leading-relaxed lg:pl-6">
            Every engagement is built for measurable outcomes — not decks. Pick
            the surface area, keep the discipline.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <motion.article
              key={s.key}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8, delay: i * 0.12 }}
              data-testid={`service-card-${s.key}`}
              className={`group relative flex flex-col rounded-2xl border p-7 sm:p-8 md:p-10 backdrop-blur-2xl transition-colors duration-500 ${
                s.featured
                  ? "border-[#D4AF37]/40 bg-gradient-to-b from-[#141005] to-[#0a0a0a]"
                  : "border-white/8 bg-white/[0.02] hover:border-white/20"
              }`}
            >
              {s.featured && (
                <div className="absolute top-4 right-4 text-[10px] uppercase tracking-[0.22em] text-black bg-[#D4AF37] px-2.5 py-1 rounded-full">
                  Signature
                </div>
              )}
              <div className="flex items-start justify-between">
                <div className="font-display text-[#D4AF37] text-xl">{s.number}</div>
                <div className="text-[11px] uppercase tracking-[0.24em] text-white/45">
                  {s.duration}
                </div>
              </div>

              <h3 className="mt-7 sm:mt-8 font-display text-2xl sm:text-3xl md:text-[34px] text-white leading-tight">
                {s.title}
              </h3>

              <div className="mt-3 flex items-baseline gap-2">
                <div className="font-display text-white text-3xl sm:text-4xl">{s.price}</div>
                <div className="text-white/50 text-sm">{s.priceNote}</div>
              </div>

              <div className="my-8 h-px w-full bg-white/8" />

              <ul className="space-y-3 text-white/75 text-sm">
                {s.features.map((f) => (
                  <li key={f} className="flex items-start gap-3">
                    <span className="mt-[7px] h-[6px] w-[6px] rounded-full bg-[#D4AF37]" />
                    {f}
                  </li>
                ))}
              </ul>

              <button
                onClick={() => onOpenForm?.(s.key)}
                data-testid={`service-cta-${s.key}`}
                className={`mt-10 inline-flex items-center justify-between gap-3 rounded-full px-5 py-3.5 text-sm font-medium transition-colors ${
                  s.featured
                    ? "bg-[#D4AF37] text-black hover:bg-[#f3d568]"
                    : "border border-white/25 text-white hover:border-[#D4AF37] hover:text-[#D4AF37]"
                }`}
              >
                {s.cta}
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 12h14M13 5l7 7-7 7"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  />
                </svg>
              </button>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
